module.exports = __webpack_public_path__ + "img/121.da03ddca.jpg";